"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _ramda = require("ramda");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../../utils");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _select = _interopRequireDefault(require("../select-component/select"));

var _incrementControls = _interopRequireDefault(require("../form-ui/increment-controls"));

var _element = _interopRequireDefault(require("../form-ui/element"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FieldText = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "number-input-component__FieldText",
  componentId: "sc-ozqfzj-0"
})(["min-width:78px;"]);
var NumberSelect = (0, _styledComponents["default"])(_select["default"]).withConfig({
  displayName: "number-input-component__NumberSelect",
  componentId: "sc-ozqfzj-1"
})(["display:none;"]);
var propTypes = {
  /** A boolean to represent whether the input field should be disabled */
  disabled: _propTypes.bool,

  /** A boolean to represent whether the input field has a status of error */
  error: _propTypes.bool,

  /** String for input attribute id */
  id: _propTypes.string,

  /** Number type for fetching the value from numData array */
  index: _propTypes.number,

  /** Label for number input field */
  label: _propTypes.node,

  /** Function to handle onBlur event */
  onBlur: _propTypes.func,

  /** Function to decrement values onclick */
  onDownClick: _propTypes.func,

  /** Function to handle onFocus event */
  onFocus: _propTypes.func,

  /** Function to increment values onclick */
  onUpClick: _propTypes.func,

  /** List of options, either array or object  */
  options: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.object]),

  /** Placeholder text to show while input is empty */
  placeholder: _propTypes.string,

  /** A boolean to represent whether the input field should be validated */
  required: _propTypes.bool,

  /** rows - used when this input field is in textarea mode */
  rows: _propTypes.number,

  /** A boolean to represent whether the input field has a status of success */
  success: _propTypes.bool,

  /** Value of form field, either string or number  */
  value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
};
var defaultProps = {
  disabled: false,
  error: false,
  index: 0,
  options: [],
  success: false
};

var NumberInputComponent = function NumberInputComponent(props) {
  var disabled = props.disabled,
      error = props.error,
      id = props.id,
      label = props.label,
      onBlur = props.onBlur,
      onDownClick = props.onDownClick,
      onFocus = props.onFocus,
      onUpClick = props.onUpClick,
      options = props.options,
      required = props.required,
      success = props.success,
      value = props.value;

  var _useFocus = (0, _utils.useFocus)(false, onBlur, onFocus),
      hasFocus = _useFocus[0],
      handleBlur = _useFocus[1],
      handleFocus = _useFocus[2];

  var showValue = !label || hasFocus || value;
  return /*#__PURE__*/_react["default"].createElement(_element["default"], _extends({
    hasFocus: hasFocus,
    showValue: showValue
  }, (0, _ramda.omit)(["label"], props)), /*#__PURE__*/_react["default"].createElement(FieldText, _extends({}, _utils.defaultFontSize, _utils.defaultSpacing, {
    color: "text-title",
    pl: "6px",
    textAlign: "center"
  }), value), /*#__PURE__*/_react["default"].createElement(NumberSelect, {
    disabled: disabled,
    fieldId: id,
    handleBlur: handleBlur,
    handleFocus: handleFocus,
    hasLabel: false,
    options: options,
    readOnly: true,
    required: required,
    showValue: true,
    value: value
  }), /*#__PURE__*/_react["default"].createElement(_incrementControls["default"], {
    disabled: disabled,
    error: error,
    handleDecrement: onDownClick,
    handleIncrement: onUpClick,
    hasFocus: hasFocus,
    required: required,
    success: success
  }));
};

NumberInputComponent.propTypes = propTypes;
NumberInputComponent.defaultProps = defaultProps;
NumberInputComponent.displayName = "Modules.NumberInputComponent";
var _default = NumberInputComponent;
exports["default"] = _default;